import {getGoogleTrips} from "../index"
import initialState from "./initialState"

// TYPES
export const UPDATE_USERS = "UPDATE_USERS"

// SELECTORS
export const getUsers = (state) => getGoogleTrips(state).users

// 1
export const getUser = (state, id) =>
  getUsers(state).find((item) => item.id === id)

// 2
export const getUserPayload = (state, id) => (getUser(state, id) || {}).payload

// CREATORS
export const updateUsers = (users) => ({
  type: UPDATE_USERS,
  users,
})

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USERS:
      return action.users
    default:
      return state
  }
}
